import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Games',
      component: () => import('../page/index/index'),
    },
    {
      path: '/jobsFill',
      name: 'JobsFill',
      component: () => import('../page/jobs/jobsFill'),
    },
    {
      path: '/daily',
      name: 'Daily',
      component: () => import('../page/daily/daily'),
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('../page/game/detail'),
    },
    {
      path: '/footer',
      name: 'Footer',
      component: () => import('../page/footer/footer'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js